import { render, staticRenderFns } from "./popup-app-info.vue?vue&type=template&id=4911bc74&"
import script from "./popup-app-info.vue?vue&type=script&lang=ts&"
export * from "./popup-app-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports